var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.organizationId)?_c('div',{},[(_vm.organizationId === 'big-bend-restoration')?_c('BigBendData'):_c('OtherHubData')],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }